import { render, staticRenderFns } from "./InfoDetail.vue?vue&type=template&id=09d21de7&scoped=true"
import script from "./InfoDetail.vue?vue&type=script&lang=ts"
export * from "./InfoDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d21de7",
  null
  
)

export default component.exports